import { IAddress, IDisability, IEmailAddress, IPhoneNumber, IStudy, IUserProfile, IPersonalInfo, IStudentInfo, IIce, IPhoneNumberPost, IAddressPost, ICountryPost } from '../models/user-profile-model';
import { EmailAddress, Study, UserProfile, PhoneNumber, Disability, Address, PersonalInfo, StudentInfo, Ice } from '../models/user-profile-viewmodel';

import DateTimeMapper from '@/shared/mappings/date-time-mapper';

/**
 * Mapper for the User Profile service
 */

export default class UserProfileMapper {
    public mapMapper(item: any, mapper: Function) {
        if (item) {
            return item.map((i: any) => mapper(i));
        } return [];
    }

    public mapUserProfile(item: IUserProfile, language: string): UserProfile {
        return new UserProfile(
            this.mapPersonalInfo(item.personalInfo, language),
            item.vunetId,
            this.mapStudentInfo(item.studentInfo)
        );
    }

    public mapPersonalInfo(item: IPersonalInfo, language: string): PersonalInfo {
        return new PersonalInfo(
            item.firstname,
            item.callName,
            item.displayName,
            item.lastName,
            DateTimeMapper.mapItem(item.dateOfBirth, language)
        )
    }

    public mapStudentInfo(item: IStudentInfo): StudentInfo {
        return new StudentInfo(
            item.studentNumber,
            this.mapMapper(item.emailAddresses, this.mapEmailAddress),
            this.mapMapper(item.studies, this.mapStudy),
            this.mapMapper(item.addresses, this.mapAddress),
            this.mapMapper(item.disabilities, this.mapDisability),
            this.mapMapper(item.phoneNumbers, this.mapPhoneNumber),
            this.mapIce(item.emergencyContactDetails)
        )
    }

    public mapStudy(item: IStudy): Study {
        return new Study(
            item.studyName,
            item.facultyName
        );
    }

    public mapIce(item: IIce): Ice {
        return new Ice(
            this.mapMapper(item.phoneNumbers, this.mapPhoneNumber)
        );
    }

    public mapIceReverse(item: Ice): IIce {
        return {
            phoneNumbers: this.mapMapper(item.phoneNumbers, this.mapPhoneNumberReverse)
        };
    }

    public mapEmailAddress(item: IEmailAddress): EmailAddress {
        return new EmailAddress(
            item.emailAddress,
            item.isUniversityEmail
        );
    }

    public mapPhoneNumber(phone: IPhoneNumber): PhoneNumber {
        return new PhoneNumber(
            phone.number,
            phone.countryIsoCode
        )
    }

    public mapPhoneNumberReverse(phone: PhoneNumber): IPhoneNumberPost {
        return new IPhoneNumberPost(
            phone.number,
            phone.countryCode
        )
    }

    public mapDisability(disability: IDisability): Disability {
        return new Disability(
            disability.description
        )
    }

    public mapAddress(address: IAddress): Address {
        return new Address(
            address.street,
            address.houseNumber,
            address.houseNumberExtension,
            address.zipcode,
            address.city,
            address.country.isoCode,
            address.type,
            address.validFrom,
            address.validTo
        )
    }

    public mapAddressReverse(address: Address): IAddressPost {
        return new IAddressPost(
            address.street,
            address.houseNumber,
            address.houseNumberAddition,
            address.zipcode,
            address.city,
            this.mapCountryReverse(address.country),
            address.type
        )
    }

    public mapCountryReverse(country: string): ICountryPost {
        return new ICountryPost(
            country
        )
    }
}
